<template>
  <div>
    <div class="form-section">
      <h3>Đăng nhập tài khoản <br/> TQC Tần Tử Anh</h3>
      <div class="login-inner-form">
        <form action="#" method="GET">
          <div class="form-group form-box">
            <input type="text" name="account" v-model="account" class="input-text" placeholder="Tài khoản Game">
            <i class="flaticon-user"></i>
          </div>
          <div class="form-group form-box">
            <input type="password" name="password" v-model="password" class="input-text" placeholder="Mật khẩu">
            <i class="flaticon-password"></i>
          </div>
          <div class="checkbox clearfix">
            <div class="form-check checkbox-theme"></div>
            <a href="javascript:void(0)" v-on:click="forgotPassword">Quên mật khẩu?</a>
          </div>
          <div class="form-group mb-0">
            <button type="button" v-on:click="login" class="btn-md btn-theme btn-block">Đăng Nhập</button>
          </div>
          <p class="text">Bạn chưa có tài khoản?<router-link to="/dang-ky"> Đăng ký ở đây</router-link></p>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';

  export default {
    name: 'Login',
    data() {
      return {
        account: '',
        password: '',
        token: ''
      }
    },
    props: {
      tqc_api: String,
      user: {}
    },
    mounted() {
      this.$emit('get-info', 'login')
    },
    methods: {
      forgotPassword() {
        alert('Liên hệ GM Bruce Lee để được hỗ trợ nhé!')
      },
      login() {
        if (!this.validate()) {
          alert('Vui lòng nhập đầy đủ thông tin!')
          return false
        }

        axios
          .post(`${this.tqc_api}login`, {
            account: this.account,
            password: this.password,
          })
          .then(({
            data
          }) => {
            localStorage.token = data.token
            this.$router.push({
              name: 'Account',
              params: {
                user: data
              }
            })
          })
          .catch(() => {
            alert('Sai tài khoản hoặc mật khẩu !')
          })

      },
      validate() {
        var isValid = 0
        if (this.account.length < 6) {
          isValid++
        }
        if (this.password.length < 6) {
          isValid++
        }
        return !isValid
      }
    }
  }
</script>

<style scoped>
  h3 {
    margin: 40px 0 0;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }
</style>